import axios from 'axios';
/* eslint-disable-next-line no-restricted-syntax */
import { cloneDeep } from 'lodash';
import store from './store';
import { parseJwt } from './jwtParser';

const successCallback = (response) => response;
const errorCallback = (error) => {
  if (error.config && error.config.isRetryRequest === true) {
    if (error.response.status === 401) {
      store.dispatch({ type: 'LOGGED_OUT' });
    }
    return Promise.reject(error);
  }

  if (error.response?.status === 401) {
    const requestClone = cloneDeep(error.config);
    /* eslint-disable-next-line no-use-before-define */
    return refresh()
      .then(() => axios({
        ...requestClone,
        headers: {
          ...requestClone.headers,
          Authorization: `Bearer ${window.localStorage.getItem('authToken')}`,
        },
        isRetryRequest: true,
      }));
  }

  return Promise.reject(error);
};

export const apiService = axios.create({ baseURL: `${window.env.APP_BROKERFRONT_BACKEND_URI}/api/frontend` });
apiService.defaults.headers.common['Accept-Language'] = 'pl';
apiService.interceptors.response.use(successCallback, errorCallback);
apiService.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('authToken')}`

export const apiNoAuth = axios.create({ baseURL: `${window.env.APP_BROKERFRONT_BACKEND_URI}/api` });


const authorizeUrl = '/login_check';
const nipCheckUrl = '/form/company/';
export const brokerContract = '/broker/contract';

/* eslint-disable-next-line no-shadow */
export const login = (login, password) => new Promise((resolve, reject) => apiService
  .post(
    authorizeUrl,
    {
      username: login,
      password,
    },
    {
      isRetryRequest: true,
    },
  )
  .then((response) => {
    window.localStorage.setItem('authToken', response.data.token);
    window.localStorage.setItem('authRefreshToken', response.data.refresh_token);
    apiService.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
    resolve(response);
  })
  .catch((err) => {
    reject(err);
  }));

export const checkNip = (nip) => new Promise((resolve, reject) => apiNoAuth
  .get(
    nipCheckUrl+'PL'+nip,
  )
  .then((response) => {
    resolve(response);
  })
  .catch((err) => {
    reject(err)
  }));

const switchUserUri = '/login_switch';
export const switchUser = (hash) => new Promise((resolve, reject) => apiService
  .post(
    switchUserUri,
    {
      auth_hash: hash
    }
  )
  .then((response) => {
    window.localStorage.setItem('authToken', response.data.token);
    window.localStorage.setItem('authRefreshToken', response.data.refresh_token);
    apiService.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
    resolve(response);
  })
  .catch((err) => {
    reject(err);
  }));


const refreshTokenUrl = '/login/token/refresh';
export const refresh = () => new Promise((resolve, reject) => apiService
  .post(
    refreshTokenUrl,
    {
      refresh_token: window.localStorage.getItem('authRefreshToken'),
      impersonated: parseJwt(window.localStorage.getItem('authToken'))?.impersonated
    },
    {
      isRetryRequest: true,
    },
  )
  .then((response) => {
    window.localStorage.setItem('authToken', response.data.token);
    window.localStorage.setItem('authRefreshToken', response.data.refresh_token);
    apiService.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
    resolve(response);
  })
  .catch((err) => {
    if (err.response.status === 401 || err.response.status === 500) {
      window.localStorage.removeItem('authToken');
      window.localStorage.removeItem('authRefreshToken');
      store.dispatch({ type: 'LOGGED_OUT' });
    }
    reject(err);
  }));

/* eslint-disable-next-line no-unused-vars */
export const logout = () => new Promise((resolve, reject) => {
  window.localStorage.removeItem('authToken');
  window.localStorage.removeItem('authRefreshToken');
  resolve();
});

export default apiService;
